import Box from '@mui/material/Box';
import { TypographyParagraphed } from '../TypographyParagraphed';

type GameDescriptionProps = {
  description: string;
  shouldShrink?: boolean;
};

export function GameDescription({
  description,
  shouldShrink = false,
}: GameDescriptionProps) {
  if (!description) return null;

  return (
    <Box
      overflow={'auto'}
      pr={1}
      sx={{
        backdropFilter: 'blur(5px)',
        maxHeight: '184px',
      }}
      flexShrink={shouldShrink ? 1 : undefined}
    >
      <TypographyParagraphed text={description} />
    </Box>
  );
}
